import {connect} from 'react-redux';

import {getLocation} from 'topmeteo/loc/selectors';

import MarkSafe from 'topmeteo/general/components/MarkSafe';

import Height from './Height';
import Reference from './Reference';
import Sun from './Sun';

const GridPoint = ({name, height, geocoord, sun}) => (
    <div className="grid-point">
        <span className="name">{name}</span>
        <MarkSafe className="coordinates" html={geocoord} />
        <Height {...height} />
        <Reference {...height} />
        <Sun {...sun} />
    </div>
);

const mapStateToProps = state => {
    const {gridpoint} = state;
    const {height, sun} = gridpoint;
    const {name, geocoord} = getLocation(state);

    return {
        geocoord,
        height,
        name,
        sun,
    };
};

export default connect(mapStateToProps)(GridPoint);
